import { TFunction } from 'i18next';
import { getCrmControlTableColumns } from '../../../../../data/formsAndTable/tables/dataTables/DataSource';
import { NoDataComponent } from '../../../../formsAndTable/forms/formControls/NoDataComponent';
import AjaxSourcedData from '../../../../formsAndTable/tables/dataTables/dataSource/AjaxSourcedData';
import { CrmControlAllItemsApiResponse, CrmControlStatus } from '../../../../../types/Control';

type CrmControlTableProps = {
  overdues: CrmControlAllItemsApiResponse | undefined;

  page: number;
  setPage: (page: number) => void;
  perPage: number;
  setPerPage: (perPage: number) => void;
  sort: 'asc' | 'desc';
  setSort: (sort: 'asc' | 'desc') => void;
  sortKey: string;
  setSortKey: (sortKey: string) => void;
  search: string;
  setSearch: (search: string) => void;
  totalRows: number;
  viewerTz: string;
  handleModalOpen: (leadId: number, source: string) => void;
  handleHistoryOpen: (leadId: number) => void;
  t: TFunction;
};

export const CrmControlTable = ({
  overdues,
  setPage,
  perPage,
  setPerPage,
  setSort,
  setSortKey,
  search,
  setSearch,
  totalRows,
  viewerTz,
  handleModalOpen,
  handleHistoryOpen,
  t,
}: CrmControlTableProps) => {
  return (
    <>
      {overdues?.items && (
        <AjaxSourcedData
          data={overdues.items || []}
          columns={getCrmControlTableColumns(t, viewerTz, handleModalOpen, handleHistoryOpen)}
          pagination={true}
          paginationServer={true}
          paginationPerPage={perPage}
          paginationDefaultPage={1}
          paginationTotalRows={totalRows}
          onChangePage={(p) => setPage(p)}
          onChangeRowsPerPage={(newPerPage, p) => {
            setPerPage(newPerPage);
            setPage(1); // or p, depending on your UX
          }}
          /* (optional) server sorting */
          sortServer
          onSort={(column, direction) => {
            // column.selector or column.sortField depending on your column defs
            const key = (column as any).sortField ?? (column as any).selector;
            setSort(direction);
            setSortKey(key);
          }}
          defaultSortAsc={false}
          searchServer
          searchText={search}
          onSearch={(value) => {
            setSearch(value);
            setPage(1);
          }}
          //   conditionalRowStyles={conditionalRowStyles}
          paginationRowsPerPageOptions={[20, 50, 100]}
          noDataComponent={<NoDataComponent />}
        />
      )}
    </>
  );
};
